import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Header, Modal } from 'semantic-ui-react';
import i18next from 'i18next';

class CloseOrderModal extends Component {
    render() {
        const { isVisible, onClose, onApprove } = this.props;

        return (
            <Modal dimmer='blurring'
                open={isVisible}
                onClick={onClose}
                style={{ direction: i18next.dir() }}
            >
                <Header icon='check circle' content={i18next.t('completeOrder')} />
                <Modal.Content>{i18next.t('orders.completeForm.completionWarning')}</Modal.Content>
                <Modal.Actions>
                    <Button color='red' inverted onClick={onClose}>
                        <Icon name='cancel' />{i18next.t('no')}
                    </Button>
                    <Button color='green' inverted onClick={onApprove}>
                        <Icon name='checkmark' />{i18next.t('yes')}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

CloseOrderModal.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onApprove: PropTypes.func
    
};

export default CloseOrderModal;